export default "__VITE_ASSET__228c8af4__"